<!-- 文章发表页面 -->
<template>
  <div class="content">
    <el-row class="form">
      <el-col>
        <el-form :model="ruleForm" ref="form" :rules="rules" label-width="120px">
          <el-form-item label="作者：" class="article text-bg" prop="article">
            <el-input v-model="ruleForm.article" class="inp-color"></el-input>
          </el-form-item>
          <el-form-item label="标题：" class="title text-bg" prop="title">
            <!--            maxlength="20"-->
            <el-input v-model="ruleForm.title" class="inp-color"></el-input>
          </el-form-item>
          <el-form-item label="原文链接：" class="title text-bg">
            <!--            maxlength="20"-->
            <el-input v-model="ruleForm.link" class="inp-color"></el-input>
          </el-form-item>
          <el-form-item label="设为轮播图：" class="title text-bg text-type" prop="type">
            <el-switch v-model="isBanner" @change="changeBannerSwitch" active-color="#197FFB" inactive-color="#666">
            </el-switch>
          </el-form-item>
          <el-form-item label="发布类型：" v-model="Typeid" class="title text-bg text-type" prop="type">
            <el-cascader :options="options" :disabled="flagdis" :props="{
            	value: 'id',
            	label: 'name',
            	checkStrictly: true,
            }" clearable @change="handlechange"></el-cascader>
          </el-form-item>
          <el-form-item label="封面：" class="img" v-if="flagFlag">
            <el-upload ref="imgUpload" class="avatar-uploader article-img"
              action="https://upload.xuruidea.com/uploadFile?type=1" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="getFile">
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div v-show="isBanner">上传的图片尺寸为750*300</div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!-- 富文本编辑器部分 -->
    <div id="richText">
      <el-row>
        <el-col>
          <el-row class="rich-text-row" style="clear: both">
            <el-col :span="24">
              <quill-editor class="rich-text-box" v-model="content" ref="myQuillEditor" :options="editorOption"
                @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)">
              </quill-editor>
            </el-col>
          </el-row>
          <div class="uoload_box">
            <el-upload class="upload-demo" action="https://upload.xuruidea.com/uploadFile" :on-success="handleSuccess"
            :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="3" :on-exceed="handleExceed"
            :show-file-list="true" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          </div>
          <el-row class="clearfix">
            <el-col v-if="articleInfo">
              <el-button type="primary" class="give-out theme-btn" @click.native="publishArticle('0')">保存</el-button>
              <el-button type="primary" class="del give-out" @click.native="publishArticle('1')">删除</el-button>
            </el-col>
            <el-col v-else>
              <el-button type="primary" class="give-out theme-btn" @click.native="publishArticle('2')">发布</el-button>
              <el-button type="primary" plain class="give-out" @click.native="publishArticle('3')">存入草稿箱</el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import login from "@/views/login/login";

export default {
  data() {
    return {
      articleInfo: "",
      flagdis: false, // 控制是否可选
      ruleForm: {
        article: "", // 作者
        title: "", // 标题
        link: "", // 原文链接
      },
      Typeid: ["113"], // 发布类型id
      isBanner: false, //是否小程序首页banner
      imageUrl: "", // 封面图片
      options: [], // 发布类型数据
      Typeiddata: "", // 发布类型选中的二级
      nowType: "", // 发布类型选中一级菜单名称
      link: "",
      // 富文本
      content: "",
      editorOption: {
        placeholder: "编辑文章内容",
      },
      // 校验
      rules: {
        article: [{ required: true, message: "请输入作者", trigger: "blur" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        // type:[
        //     { required: true, message: '请选择发布类型', trigger: 'blur' },
        // ],
      },
      flagFlag: false,
      fileList: []
    };
  },
  mounted() {
  },
  created() {
    this.getTree();
    // this.articleInfo = publicVue.articleInfo;
    this.articleInfo = this.$route.params.data;

    if (this.articleInfo) {
      //获取文章详情，并回显
      this.axiosGet(`/newsNotice/findById?id=${this.articleInfo.id}`).then((res) => {
        if (res.code == 200) {
          this.Typeiddata = res.data.type;
          this.nowType = res.data.nowType;
          this.ruleForm.article = res.data.author;
          this.ruleForm.link = res.data.link;
          this.ruleForm.title = res.data.title;
          this.imageUrl = res.data.outPicture;
          this.content = res.data.content;
          this.isBanner = res.data.isHomePage == 1 ? true : false;
          res.data.accessoryList.forEach(item=>{
            this.fileList.push({
              name:item.accessoryName,
              response:{
                data:{
                  httpsUrl:item.url
                }
              }
            })
          })
        }
      });
    }
    // this.articleInfo = this.$route.params.data;
    // if (this.$route.params.data) {
    // 	this.ruleForm.article = this.articleInfo.author;
    // 	this.ruleForm.title = this.articleInfo.title;
    // 	this.ruleForm.link = this.articleInfo.link;
    // 	this.isBanner = this.articleInfo.isHomePage;
    // 	this.Typeid = this.articleInfo.nowType;
    // 	this.imageUrl = this.articleInfo.outPicture;
    // 	this.content = this.articleInfo.content;
    // }
  },
  methods: {
    handleSuccess(response, file, fileList) {
      this.fileList = fileList
    },
    handleRemove(file, fileList){
      this.fileList.forEach((item,index)=>{
        if(file.name==item.name){
          this.fileList.splice(index,1)
        }
      })
    },
    beforeRemove(){},
    handleExceed(){},
    // 选择类型
    handlechange(data) {
      console.log(data);
      var data1 = data.slice(-1);
      let grouping = data1.toString();
      this.Typeiddata = grouping;
      this.nowType = data[0];
    },
    // 小程序新闻树
    getTree() {
      this.axiosGet(`/common/findSysDictByNewsNoticeTree?code=${"journalism_menu"}`).then((res) => {
        if (res.code == 200) {
          this.options = res.data;
        }
      });
    },
    // 文件上传
    handleAvatarSuccess(res, file) {
      this.imageUrl = file.response.data.httpsUrl;
      // console.log(res,file)
    },
    // 判断大小与尺寸上传图片
    getFile(file) {
      if (this.isBanner) {
        // console.log(file)
        // const isJPG = file.type === 'image/jpeg'
        // const isPNG = file.type === 'image/png'
        // const isAVIF = file.type === 'image/avif'
        // const isLt1K = file.size / 1024 < 512
        //
        // if (!isJPG && !isPNG && !isAVIF) {
        //   this.$message.error('上传的图片只能是 JPG/PNG/AVIF 格式!')
        // }
        // if (!isLt1K) {
        //   this.$message.error('上传图片大小不能超过 512KB!')
        // }
        // return (isJPG || isPNG || isAVIF) && isLt1K && new Promise(function (resolve, reject) {
        //   let img = new Image()
        //   let fileBlobName = null
        //   if (window.createObjectURL !== undefined) {
        //     fileBlobName = window.createObjectURL(file)
        //   } else if (window.URL !== undefined) {
        //     fileBlobName = window.URL.createObjectURL(file)
        //   } else if (window.webkitURL !== undefined) {
        //     fileBlobName = window.webkitURL.createObjectURL(file)
        //   }
        //   img.src = fileBlobName
        //   img.onload = () => {
        //     let width = 750
        //     let height = 300
        //     const resSize = img.width == width && img.height ==height
        //     const resRate = img.width / img.height === 2
        //     console.log(resSize, resRate)
        //     if (resSize && resRate) {
        //       resolve()
        //     } else if (resRate) {
        //       this.$message.error("上传图片尺寸须大于400px*200px!");
        //       reject(img)
        //     } else {
        //       this.$message.error("上传图片长宽比需为(2:1)");
        //       reject(img)
        //     }
        //   }
        // })

        // 普通文章则不限制大小
        const isJpg = /image\/(png|jpe?g|gif)$/.test(file.type);
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJpg) {
          this.$message.error("上传图片只能是 JPG/PNG 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 2MB!");
        }


        const isSize = new Promise(function (resolve, reject) {
          let width = 750;
          let height = 300;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function () {
            let valid = img.width == width && img.height == height;
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then(
          () => {
            return file;
          },
          () => {
            this.$message.error("上传图片的尺寸不对");
            return Promise.reject();
          }
        );
        return isJpg && isLt2M && isSize;
      }
    },
    changeBannerSwitch() {
      this.imageUrl = "";
      this.flagdis = !this.flagdis;
      if (this.flagdis == true) {
        this.flagFlag = true
      } else {
        this.flagFlag = false
      }
      this.$refs.imgUpload.clearFiles();
    },
    // 富文本编辑器
    onEditorBlur() {
      //失去焦点事件
    },
    onEditorFocus() {
      //获得焦点事件
    },
    onEditorChange() {
      //内容改变事件
    },
    // 发布
    publishArticle(flag) {
      // flag 0保存 1删除  2发布
      let that = this;
      let isHomeBanner = this.isBanner == true ? 1 : 0;
      let accessoryList=[]
      this.fileList.forEach(item=>{
        accessoryList.push({
          accessoryName:item.name,
          url:item.response.data.httpsUrl
        })
      })
      if (flag == '3') {
        // 草稿箱
        this.axiosPost("/newsNotice/add", {
          title: this.ruleForm.title, // 标题
          outPicture: this.imageUrl, // 外图片
          author: this.ruleForm.article, // 作者
          type: this.Typeiddata, // 发布类型
          nowType: this.nowType,
          content: this.content, // 内容
          isHomePage: isHomeBanner, //是否小程序端首页banner
          link: this.ruleForm.link,
          accessoryList:accessoryList, //附件
          status:2,//发布状态
        }).then((res) => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "success",
              duration: "1800",
            });
            this.$router.push({
              path: '/articleHome',
              replace: true
            })
          }
          that.$emit("statusFun", true);
        });
      } else if (flag == "2") {
        this.axiosPost("/newsNotice/add", {
          title: this.ruleForm.title, // 标题
          outPicture: this.imageUrl, // 外图片
          author: this.ruleForm.article, // 作者
          type: this.Typeiddata, // 发布类型
          nowType: this.nowType,
          content: this.content, // 内容
          isHomePage: isHomeBanner, //是否小程序端首页banner
          link: this.ruleForm.link,
          accessoryList:accessoryList, //附件
          status:1,//发布状态
        }).then((res) => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "success",
              duration: "1800",
            });
            this.$router.push({
              path: '/articleHome',
              replace: true
            })
          }
          that.$emit("statusFun", true);
        });
      } else if (flag == "0") {
        if (!this.ruleForm.article.trim() || !this.ruleForm.title.trim()) {
          this.$message({
            type: "warning",
            message: "作者或标题为空！",
            duration: 1000,
          });
          return;
        }
        let userInfoId = JSON.parse(sessionStorage.getItem("userInfo")).id;
        this.axiosPost("/newsNotice/update", {
          id: this.articleInfo.id, // 文章id
          title: this.ruleForm.title,
          type: this.Typeiddata,
          outPicture: this.imageUrl,
          nowType: this.nowType,
          updateEmp: userInfoId, // 管理员id
          author: this.ruleForm.article, // 作者
          content: this.content,
          isHomePage: isHomeBanner, //是否小程序端首页banner
          accessoryList:accessoryList, //附件
        }).then((res) => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "success",
              duration: "1800",
            });
            this.$router.push({
              path: '/articleHome',
              replace: true
            })
            that.$emit("statusFun", true);
          }
        });
      } else if (flag == "1") {
        this.axiosPost("/newsNotice/delById", {
          id: this.articleInfo.id,
        }).then((res) => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "success",
              duration: "1800",
            });
            this.$router.push({
              path: '/articleHome',
              replace: true
            })
          }
        });
        that.$emit("statusFun", true);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .form {
    width: 80%;
    margin-top: 2%;
    padding-top: 5%;
    background-color: #fff;
  }

  #richText {
    width: 80%;
  }
  .uoload_box{
    width: 50%;
  }
}

.article {
  width: 51.2%;
}

.title {
  width: 71.5%;
}

.text-type {
  text-align: left;
}

// 文章封面上传
.avatar-uploader {
  width: 200px;
  height: 100px;
  border: 1px dashed #d9d9d9;

  .el-upload {
    width: 100%;
    height: 100%;
    text-align: center;
  }
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  line-height: 100px;
}

.avatar {
  // 图片样式
  width: 100%;
  height: 100%;
  display: block;
}

// 富文本
#richText {
  background-color: #ffffff;
  min-height: 200px;
  position: relative;
  // background-color:red;
  padding-bottom: 60px;
}

.rich-text-box {
  min-height: 300px;
  // background-color:red;
}

.give-out {
  width: 128px;
  height: 46px;
  float: right;
  margin-right: 5%;
  font-size: 9px;
}

.del.give-out {
  color: #1a80fc;
  background-color: #e6ecf8;
}

.clearfix {
  width: 100%;
  position: absolute;
  height: 60px;
  bottom: -60px;
  right: 0;
}
</style>
